import axios from 'axios'
import { i18n } from '../../plugins/i18n'

export const companiesFranchisee = {
  namespaced: true,
  state: {
    data: null,
    loading: false,
    loadError: false,
    errors: null,
    message: null,
  },
  mutations: {
    apiConnect(state) {
      state.loading = true
      state.loadError = false
      state.errors = null
    },
    readFranchiseeSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
      state.loadError = false
    },
    apiSuccess(state, message) {
      state.loading = false
      state.loadError = false
      state.message = message
    },
    apiFailure(state, errors) {
      state.loading = false
      state.loadError = true
      state.errors = errors.response.data.errors[0].detail
    }
  },
  actions: {
    readFranchisee({ commit }, { company_uuid, franchisee_id }) {
      commit('apiConnect')
      return axios
        .get('/api/companies/' + company_uuid + '/franchisees/' + franchisee_id + '.json', {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then(res => {
          commit('readFranchiseeSuccess', res.data)
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
    createFranchisee({ commit }, { company_uuid, payload }) {
      commit('apiConnect')
      return axios
        .post('/api/companies/' + company_uuid + '/franchisees.json', payload, {
          headers: {
            'Accept': 'application/json',
          },
        })
        .then(() => {
          commit('apiSuccess', i18n.t('messages.created', { value: i18n.t('models.franchisee.modelName') }))
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
    updateFranchisee({ commit }, { company_uuid, franchisee_id, payload }) {
      commit('apiConnect')
      return axios
        .patch('/api/companies/' + company_uuid + '/franchisees/' + franchisee_id + '.json', payload, {
          headers: {
            'Accept': 'application/json',
          },
        })
        .then(() => {
          commit('apiSuccess', i18n.t('messages.updated', { value: i18n.t('models.franchisee.modelName') }))
        })
        .catch(err => {
          commit('apiFailure', err)
          console.error(err)
        })
    },
  }
}
